import * as products from 'app/mocks/data/catalogue/products/list'
import * as Managers from 'app/mocks/data/park/managers/list'
import * as sites from 'app/mocks/data/park/sites/list'
import * as konvives from 'app/mocks/data/users/konvives/list'

import { newDateFormatted } from 'app/utils/date'

import { Order, StatusOrder } from 'app/types/operations/order'

export const order601: Order = {
    id: 601,
    status: StatusOrder.enum.EXPIRED,
    konvive: konvives.konvive1,
    site: sites.site1,
    price: 6,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: true,
            quantity: 100,
        },
        {
            product: products.product2,
            is_weight_quantity: true,
            quantity: 500,
        },
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product4,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-20)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-20)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-20)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-1)}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager8,
            changes: [],
        },
    ],
}

export const order602: Order = {
    id: 602,
    status: StatusOrder.enum.EXPIRED,
    konvive: konvives.konvive2,
    site: sites.site1,
    price: 6,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product2,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-19)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive2,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-19)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-19)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-1)}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager3,
            changes: [],
        },
    ],
}

export const order603: Order = {
    id: 603,
    status: StatusOrder.enum.EXPIRED,
    phone_number: '0633445566',
    site: sites.site2,
    price: 6,
    articles: [
        {
            product: products.product5,
            is_weight_quantity: true,
            quantity: 300,
        },
        {
            product: products.product6,
            is_weight_quantity: true,
            quantity: 450,
        },
        {
            product: products.product7,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product8,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-18)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0633445566',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-18)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-18)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager3,
            changes: [],
        },
    ],
}

export const order604: Order = {
    id: 604,
    status: StatusOrder.enum.EXPIRED,
    konvive: konvives.konvive3,
    site: sites.site3,
    price: 6,
    articles: [
        {
            product: products.product9,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product10,
            is_weight_quantity: true,
            quantity: 275,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-17)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-17)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-17)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager5,
            changes: [],
        },
    ],
}

export const order605: Order = {
    id: 605,
    status: StatusOrder.enum.EXPIRED,
    phone_number: '0644556677',
    site: sites.site4,
    price: 6,
    articles: [
        {
            product: products.product11,
            is_weight_quantity: true,
            quantity: 200,
        },
        {
            product: products.product12,
            is_weight_quantity: true,
            quantity: 350,
        },
        {
            product: products.product13,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product14,
            is_weight_quantity: true,
            quantity: 150,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-16)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0644556677',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-16)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-16)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager5,
            changes: [],
        },
    ],
}

export const order606: Order = {
    id: 606,
    status: StatusOrder.enum.EXPIRED,
    konvive: konvives.konvive4,
    site: sites.site5,
    price: 6,
    articles: [
        {
            product: products.product15,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-15)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-15)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-15)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager2,
            changes: [],
        },
    ],
}

export const order607: Order = {
    id: 607,
    status: StatusOrder.enum.EXPIRED,
    phone_number: '0655667788',
    site: sites.site6,
    price: 6,
    articles: [
        {
            product: products.product16,
            is_weight_quantity: true,
            quantity: 425,
        },
        {
            product: products.product17,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product18,
            is_weight_quantity: true,
            quantity: 225,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-14)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0655667788',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-14)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-14)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager2,
            changes: [],
        },
    ],
}

export const order608: Order = {
    id: 608,
    status: StatusOrder.enum.EXPIRED,
    konvive: konvives.konvive5,
    site: sites.site7,
    price: 6,
    articles: [
        {
            product: products.product19,
            is_weight_quantity: true,
            quantity: 175,
        },
        {
            product: products.product20,
            is_weight_quantity: true,
            quantity: 375,
        },
        {
            product: products.product21,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product22,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-13)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-13)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-13)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager1,
            changes: [],
        },
    ],
}

export const order609: Order = {
    id: 609,
    status: StatusOrder.enum.EXPIRED,
    phone_number: '0666778899',
    site: sites.site8,
    price: 6,
    articles: [
        {
            product: products.product23,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-12)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0666778899',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-12)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-12)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager1,
            changes: [],
        },
    ],
}

export const order610: Order = {
    id: 610,
    status: StatusOrder.enum.EXPIRED,
    konvive: konvives.konvive6,
    site: sites.site9,
    price: 6,
    articles: [
        {
            product: products.product24,
            is_weight_quantity: true,
            quantity: 550,
        },
        {
            product: products.product1,
            is_weight_quantity: true,
            quantity: 250,
        },
        {
            product: products.product2,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-11)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-11)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-11)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager7,
            changes: [],
        },
    ],
}

export const order611: Order = {
    id: 611,
    status: StatusOrder.enum.EXPIRED,
    phone_number: '0677889900',
    site: sites.site10,
    price: 6,
    articles: [
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product4,
            is_weight_quantity: true,
            quantity: 625,
        },
        {
            product: products.product5,
            is_weight_quantity: true,
            quantity: 325,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-10)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0677889900',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-10)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-10)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager7,
            changes: [],
        },
    ],
}

export const order612: Order = {
    id: 612,
    status: StatusOrder.enum.EXPIRED,
    konvive: konvives.konvive7,
    site: sites.site11,
    price: 6,
    articles: [
        {
            product: products.product6,
            is_weight_quantity: true,
            quantity: 400,
        },
        {
            product: products.product7,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product8,
            is_weight_quantity: true,
            quantity: 275,
        },
        {
            product: products.product9,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-9)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-9)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-9)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager6,
            changes: [],
        },
    ],
}

export const order613: Order = {
    id: 613,
    status: StatusOrder.enum.EXPIRED,
    phone_number: '0688990011',
    site: sites.site12,
    price: 6,
    articles: [
        {
            product: products.product10,
            is_weight_quantity: true,
            quantity: 525,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-8)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0688990011',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-8)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-8)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager6,
            changes: [],
        },
    ],
}

export const order614: Order = {
    id: 614,
    status: StatusOrder.enum.EXPIRED,
    konvive: konvives.konvive8,
    site: sites.site13,
    price: 6,
    articles: [
        {
            product: products.product11,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product12,
            is_weight_quantity: true,
            quantity: 475,
        },
        {
            product: products.product13,
            is_weight_quantity: true,
            quantity: 225,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-7)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-7)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-7)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager4,
            changes: [],
        },
    ],
}

export const order615: Order = {
    id: 615,
    status: StatusOrder.enum.EXPIRED,
    phone_number: '0699001122',
    site: sites.site14,
    price: 6,
    articles: [
        {
            product: products.product14,
            is_weight_quantity: true,
            quantity: 350,
        },
        {
            product: products.product15,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product16,
            is_weight_quantity: true,
            quantity: 175,
        },
        {
            product: products.product17,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-6)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0699001122',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-6)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-6)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager4,
            changes: [],
        },
    ],
}

export const order616: Order = {
    id: 616,
    status: StatusOrder.enum.EXPIRED,
    konvive: konvives.konvive9,
    site: sites.site15,
    price: 6,
    articles: [
        {
            product: products.product18,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product19,
            is_weight_quantity: true,
            quantity: 450,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-5)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-5)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-5)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager9,
            changes: [],
        },
    ],
}

export const order617: Order = {
    id: 617,
    status: StatusOrder.enum.EXPIRED,
    phone_number: '0610112233',
    site: sites.site16,
    price: 6,
    articles: [
        {
            product: products.product20,
            is_weight_quantity: true,
            quantity: 575,
        },
        {
            product: products.product21,
            is_weight_quantity: true,
            quantity: 300,
        },
        {
            product: products.product22,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-4)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0610112233',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-4)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-4)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager9,
            changes: [],
        },
    ],
}

export const order618: Order = {
    id: 618,
    status: StatusOrder.enum.EXPIRED,
    konvive: konvives.konvive10,
    site: sites.site17,
    price: 6,
    articles: [
        {
            product: products.product23,
            is_weight_quantity: true,
            quantity: 425,
        },
        {
            product: products.product24,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product1,
            is_weight_quantity: true,
            quantity: 250,
        },
        {
            product: products.product2,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-3)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-3)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-3)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager10,
            changes: [],
        },
    ],
}

export const order619: Order = {
    id: 619,
    status: StatusOrder.enum.EXPIRED,
    phone_number: '0621223344',
    site: sites.site18,
    price: 6,
    articles: [
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-2)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0621223344',
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-2)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-2)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager10,
            changes: [],
        },
    ],
}

export const order620: Order = {
    id: 620,
    status: StatusOrder.enum.EXPIRED,
    konvive: konvives.konvive1,
    site: sites.site19,
    price: 6,
    articles: [
        {
            product: products.product4,
            is_weight_quantity: true,
            quantity: 600,
        },
        {
            product: products.product5,
            is_weight_quantity: true,
            quantity: 200,
        },
        {
            product: products.product6,
            is_weight_quantity: false,
            quantity: 4,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-1)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-1)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: Managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-1)}T11:00:00`,
            status: StatusOrder.enum.READY,
            author: Managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted()}T00:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: Managers.manager8,
            changes: [],
        },
    ],
}
